<template>
  <v-menu
    v-model="menuContainer"
    :class="{ 'v-menu__activator--disabled': !isSuccess }"
    :close-on-content-click="false"
    :open-on-click="false"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="!isSuccess"
      flat
      @click="toggleDropdown"
    >
      <span class="toolbar__button-label">
        <span v-if="selectedItem" class="autocomplete__text autocomplete__text--active">{{ selectedItem }}</span>
        <span v-else class="autocomplete__text">
          {{ $t('Common.by') }} <span class="text--lowercase">{{ label }}</span>
        </span>
      </span>
      <v-icon right small v-if="!isSelected">keyboard_arrow_down</v-icon>
      <v-icon right small color="accent" v-if="isSelected" id="menu-item__clear" @click="toggleDropdown">close</v-icon>
    </v-btn>

    <v-list class="v-list--custom">
      <v-list-tile
        v-for="item in items"
        :key="item.value"
        @click="getSelectedItem(item)"
      >
        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'MenuItemDropdown',
  props: {
    filters: Object,
    type: String,
    status: {
      type: Number,
      default: STATUS_SUCCESS
    },
    label: {
      type: String,
      require: true
    },
    items: {
      type: [Array],
      require: true
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      menuContainer: false,
      selectedItem: null,
      isSelected: false
    }
  },
  methods: {
    resetProps () {
      this.updateFilters()
      this.menuContainer = false
      this.isSelected = false
      this.selectedItem = null
    },

    toggleDropdown ($event) {
      if ($event.target.id === 'menu-item__clear') {
        this.resetProps()
        return
      }
      this.menuContainer = true
    },

    updateFilters (value = null) {
      this.$emit('change', { [this.type]: value })
    },

    getSelectedItem ({ value, text }) {
      this.updateFilters(value)
      this.menuContainer = false
      this.isSelected = true
      this.selectedItem = text
    }
  }
}
</script>
